import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth uses httpOnly cookies (set by the backend). withCredentials sends them.
// No token is kept in JS-accessible storage, so it is not exposed to XSS.
const api = axios.create({ baseURL: API, withCredentials: true });

let lastBlockedToast = 0;
api.interceptors.response.use((r) => r, (err) => {
  if (err?.response?.status === 403 && err.response.data?.detail === "account_blocked" && Date.now() - lastBlockedToast > 4000) {
    lastBlockedToast = Date.now();
    import("sonner").then(({ toast }) => toast.error("Your account is blocked — generating and spending credits are paused."));
  }
  return Promise.reject(err);
});

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (detail === "account_blocked") return "Your account is blocked.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
